/**
 * API Configuration
 * Centralized configuration for API calls
 * Works in both server and client components
 */



const BASE_URL = process.env.NEXT_PUBLIC_PROXY_BASE_URL
const API_ORIGIN = process.env.NEXT_PUBLIC_BASE_URL


if (!BASE_URL) {
  console.error("NEXT_PUBLIC_PROXY_BASE_URL env is Required");
}

if (!API_ORIGIN) {
  console.error("NEXT_PUBLIC_BASE_URL env is Required");
}

/**
 * Get API headers for authenticated requests
 * Works in both server and client components
 */
export function getAPIHeaders(): HeadersInit {
  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  // Add origin if available (helps with CORS)
  if (API_ORIGIN) {
    headers["Origin"] = API_ORIGIN;
  }

  return headers;
}

/**
 * Get WordPress API headers (no authorization needed)
 * WordPress APIs don't need the secret key
 */
export function getWPHeaders(): HeadersInit {
  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  // Add origin if available (helps with CORS)
  if (API_ORIGIN) {
    headers["Origin"] = API_ORIGIN;
  }

  return headers;
}

/**
 * Get fetch options with CORS configuration
 * Use this for API calls that need CORS handling
 */
export function getAPIFetchOptions(cacheOptions?: RequestInit): RequestInit {
  return {
    ...cacheOptions,
    method: "GET",
    headers: getAPIHeaders(),
    mode: "cors" as RequestMode,
    credentials: "omit" as RequestCredentials,
  };
}

/**
 * Get error message for missing configuration
 */
export function getConfigErrorMessage(): string {
  const missing: string[] = [];

  if (!BASE_URL) missing.push("NEXT_PUBLIC_API_BASE_URL");

  if (missing.length > 0) {
    return `Missing environment variables: ${missing.join(", ")}`;
  }

  return "API configuration is valid";
}
